import React, { Component } from 'react';

import './Reports.css';

import { background_10, services2, services9 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Documents from '../../components/Documents/Documents';
import { DOCUMENT_CATEGORIES } from '../../utils/documents';
import { Helmet } from 'react-helmet';
import { get_page_title } from '../../utils/config';

interface Props{
}
interface State{
}

class Reports extends Component<Props,State>{
    render(){
        return (
        <Page 
            id="reports"
            banner={{
                title: "reports",
                bannerImage: background_10,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title(`DAMPS - Reports`) }</title>
                <meta 
                    name="description" 
                    content="DAMPS reports details"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    {
                        DOCUMENT_CATEGORIES["Reports"]?.map((category:string, index:number)=>(
                            <Documents
                                default_toggled={index === 0}
                                category={category}
                            />
                        ))
                    }
                </div>
            </div>
        </Page>
        );
    }

};


export default Reports;
